// Wrap all words in the span

export default {
  inserted: (el) => {
    const p = el.querySelectorAll('p');
    for (let text = 0; text < p.length; text += 1) {
      const div = document.createElement('p');
      let words = p[text].innerHTML.replace(/<span>/g, '<span class="text-blow">');
      words = words.replace(/[а-яА-Я]*,/g, '<span class="text-blow-word">$&</span>');
      words = words.replace(/\d.*\d|[а-яА-Я]+&nbsp;+[а-яА-Я]+|\W!(\/|>|<|=)/g, '<span class="text-blow-word">$&</span>');
      words = words.replace(/\d.*\d\s|[а-яА-Я]+|\W!(\/|>|<|=)/g, '<span class="text-blow-word">$&</span>');
      words = words.replace(/\.\//g, '<span class="text-blow-word">$&</span>');
      words = words.replace(/\.|,|: |\/ |«|»/g, '<span class="text-blow-word">$&</span>');
      // words = words.replace(/,|\./g, '<span class="text-blow-word">$&</span>');
      div.innerHTML = words;

      p[text].parentNode.replaceChild(div, p[text]);
    }
  },
};



// WEBPACK FOOTER //
// ./src/directives/text-blow.js